import { FieldArray } from "formik";
import {
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
  Label,
  FormGroup,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import SelectField from "../../Utils/SelectField";
import InputField from "../../Utils/InputField";
import { Link } from "react-router-dom";
import { removeRowsFromGrantsAndCharges } from "./constants/checkEmptyFields";
import {
  grantsAndChargesHandle,
  handleGrantsAndChargesResourceValueAndUsageFields,
  handleInfiniteForGrantsAndCharges,
} from "./constants/GrantsAndRecurringFunctions";
import {
  GrantsValidityEnd,
  SubscriptionEndsOnOptions,
  SubscriptionStartsOnOptions,
  TimePeriodGrantOptions,
  TimePeriodOptions,
  ValidityGrantsOneTimeStartsOnOptions,
  ValidityStartsOnOptions,
} from "./constants/initialValues";
import { useContext, useEffect, useState } from "react";
import CommonDateTimePicker from "../../Utils/CommonDateTimePicker";
import moment from "moment";
import { handleGrantsOverrideState } from "./constants/displayInfinite";
import { CreateOfferContext } from "./context";
import { LabelText } from "../../Utils/Input";

export default function GrantsOneTime({ pushRef }) {
  const {
    touched,
    isEdit,
    errors,
    loading,
    values,
    resourceData,
    handleChange,
    disableValidityInGrantOne,
    setDisableValidityInGrantOneTime,
    overrideState,
    infiniteOptions,
    grantResourceOptions,
    setTouched,
    setFieldTouched,
    setFieldValue,
    isEmptyorInvalidFieldForGrantsAndCharges,
    isSubscribed,
    isCreate,
  } = useContext(CreateOfferContext);
  const { sectionRefs } = useContext(CreateOfferContext);

  return (
    <FieldArray name="grants">
      {({ push, remove }) => {
        pushRef.current = push;
        return (
          <div className="live-preview">
            {values?.grants?.length === 0 &&
            values?.recurringGrants?.length > 0 ? (
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{ marginTop: "120px" }}
              >
                {isSubscribed ? (
                  <div className="text-center mb-2">
                    There are no Grants available for this offer.
                  </div>
                ) : (
                  <div className="text-center mb-2">
                    There are no Grants available for this offer, Add a Grant to
                    proceed.
                  </div>
                )}
              </div>
            ) : (
              values?.grants?.map((val, index) => {
                const keyIndex = values?.grants?.length - (index + 1);
                const grantRef = sectionRefs.current[`grants${keyIndex + 1}`];
                return (
                  <div
                    key={keyIndex}
                    className="border border-opacity-50 rounded-0 mb-3"
                    ref={grantRef}
                  >
                    <Row className="mb-0 px-3 pt-3">
                      <Col
                        xs={12}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <h3 className="card-title mb-0">
                          Grant {keyIndex > 0 ? keyIndex + 1 : ""}
                        </h3>
                        {!isSubscribed && (
                          <div>
                            <Link
                              to="#"
                              className="link-primary me-2"
                              onClick={() => {
                                const clonedGrant = {
                                  ...values.grants?.[keyIndex],
                                };
                                !isEmptyorInvalidFieldForGrantsAndCharges(
                                  keyIndex,
                                  values.grants
                                ) && push(clonedGrant);
                              }}
                            >
                              <i
                                data-testid="clone"
                                className="ri-file-copy-line"
                              ></i>
                            </Link>
                            <Link
                              to="#"
                              className="link-danger"
                              onClick={() => {
                                remove(keyIndex);
                              }}
                            >
                              <i
                                data-testid="delete"
                                className="ri-delete-bin-5-line"
                              ></i>
                            </Link>
                          </div>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3 px-3 pt-3">
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`grants[${keyIndex}].resourceType`}>
                          Resource Type<span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`grants[${keyIndex}].resourceType`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            (touched?.grants &&
                              touched?.grants?.[keyIndex] &&
                              !values?.grants?.[keyIndex].resourceType &&
                              !disableValidityInGrantOne[keyIndex]) ||
                            false
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.grants?.[keyIndex]?.resourceType &&
                            errors?.grants?.[keyIndex]?.resourceType
                              ? errors?.grants?.[keyIndex]?.resourceType
                              : "Select Resource Type"
                          }
                        />
                        <SelectField
                          isLoading={loading}
                          className={
                            (touched?.grants &&
                              touched?.grants?.[keyIndex] &&
                              !values?.grants?.[keyIndex]?.resourceType &&
                              !disableValidityInGrantOne[keyIndex]) ||
                            false
                              ? "error-input"
                              : ""
                          }
                          name={`grants[${keyIndex}].resourceType`}
                          placeholder={" "}
                          isDisabled={isSubscribed}
                          value={values?.grants?.[keyIndex]?.resourceType}
                          handleChange={grantsAndChargesHandle(
                            `values.grants[${keyIndex}].resourceType`,
                            values?.grants?.[keyIndex],
                            setFieldValue,
                            setFieldTouched,
                            resourceData,
                            setDisableValidityInGrantOneTime,
                            keyIndex
                          )}
                          options={grantResourceOptions}
                          isRVStyle={true}
                        />
                      </Col>
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`grants[${keyIndex}].resourceValue`}>
                          Resource Value
                          <span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`grants[${keyIndex}].resourceValue`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            (touched?.grants &&
                              touched?.grants?.[keyIndex] &&
                              !values?.grants?.[keyIndex]?.resourceValue &&
                              !disableValidityInGrantOne[keyIndex]) ||
                            false
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.grants?.[keyIndex]?.resourceValue &&
                            errors?.grants?.[keyIndex]?.resourceValue
                              ? errors?.grants?.[keyIndex]?.resourceValue
                              : "Enter Resource Value"
                          }
                        />
                        <InputField
                          name={`grants[${keyIndex}].resourceValue`}
                          className={"form-control"}
                          type="number"
                          handleChange={handleGrantsAndChargesResourceValueAndUsageFields(
                            handleChange
                          )}
                          value={values?.grants?.[keyIndex]?.resourceValue}
                          invalid={
                            errors?.grants &&
                            errors?.grants?.[keyIndex] &&
                            touched?.grants &&
                            touched?.grants?.[keyIndex] &&
                            touched?.grants?.[keyIndex]?.resourceValue &&
                            errors?.grants?.[keyIndex]?.resourceValue
                              ? true
                              : false
                          }
                        />
                      </Col>

                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label>Type of Resource</Label>
                        <LabelText
                          htmlFor={`grants[${keyIndex}].nonCurrency`}
                          classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                          displayText={"Non-Currency"}
                        />
                        <InputField
                          name={`grants[${keyIndex}].nonCurrency`}
                          className={` ${
                            isEdit ? "label-disable-color-edit-offer" : ""
                          }`}
                          value={"Non-Currency"}
                          disabled
                        />
                      </Col>
                      {values?.grants?.[keyIndex]?.ceiling ? (
                        <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                          <Label for={`grants[${keyIndex}].ceiling`}>
                            Ceiling
                          </Label>
                          <LabelText
                            htmlFor={`grants[${keyIndex}].ceiling`}
                            classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                            displayText={"Enter Ceiling"}
                          />
                          <InputField
                            name={`grants[${keyIndex}].ceiling`}
                            className={` ${
                              isEdit ? "label-disable-color-edit-offer" : ""
                            }`}
                            value={values?.grants?.[keyIndex]?.ceiling}
                            disabled
                          />
                        </Col>
                      ) : null}
                      {values?.grants?.[keyIndex]?.floor ? (
                        <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                          <Label for={`grants[${keyIndex}].floor`}>Floor</Label>
                          <LabelText
                            htmlFor={`grants[${keyIndex}].floor`}
                            classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                            displayText={"Enter Floor"}
                          />
                          <InputField
                            name={`grants[${keyIndex}].floor`}
                            className={` ${
                              isEdit ? "label-disable-color-edit-offer" : ""
                            }`}
                            value={values?.grants?.[keyIndex]?.floor}
                            disabled
                          />
                        </Col>
                      ) : null}
                      {values?.grants?.[keyIndex]?.infinite && (
                        <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                          <Label for={`grants[${keyIndex}].infinite`}>
                            Infinite
                          </Label>
                          <LabelText
                            htmlFor={`grants[${keyIndex}].infinite`}
                            classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                            displayText={"Select Infinite"}
                          />

                          <SelectField
                            name={`grants[${keyIndex}].infinite`}
                            placeholder={" "}
                            value={values?.grants?.[keyIndex]?.infinite}
                            isDisabled={isSubscribed}
                            handleChange={handleInfiniteForGrantsAndCharges(
                              `grants[${keyIndex}].infinite`,
                              values?.grants?.[keyIndex],
                              setFieldValue
                            )}
                            options={infiniteOptions}
                            isRVStyle={true}
                          />
                        </Col>
                      )}
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`grants[${keyIndex}].validityStartsOn`}>
                          Validity Starts
                          <span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`grants[${keyIndex}].validityStartsOn`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            (touched?.grants &&
                              touched?.grants?.[keyIndex] &&
                              !values?.grants?.[keyIndex]?.validityStartsOn &&
                              !disableValidityInGrantOne[keyIndex]) ||
                            false
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.grants?.[keyIndex]?.validityStartsOn &&
                            errors?.grants?.[keyIndex]?.validityStartsOn
                              ? errors?.grants?.[keyIndex]?.validityStartsOn
                              : "Select Validity Starts"
                          }
                        />
                        <SelectField
                          isLoading={loading}
                          className={
                            (touched?.grants &&
                              touched?.grants?.[keyIndex] &&
                              !values?.grants?.[keyIndex]?.validityStartsOn &&
                              !disableValidityInGrantOne[keyIndex]) ||
                            false
                              ? "error-input"
                              : ""
                          }
                          name={`grants[${keyIndex}].validityStartsOn`}
                          placeholder={" "}
                          isDisabled={
                            (isEdit && isSubscribed) ||
                            (disableValidityInGrantOne[keyIndex] && isCreate)
                          }
                          value={values?.grants?.[keyIndex]?.validityStartsOn}
                          handleChange={(value) => {
                            setFieldValue(
                              `grants[${keyIndex}].validityStartsOn`,
                              value
                            );
                          }}
                          options={ValidityGrantsOneTimeStartsOnOptions}
                          isRVStyle={true}
                        />
                      </Col>
                      {values.grants?.[keyIndex]?.validityStartsOn?.label ===
                        "Specific Time" && (
                        <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                          <Label>
                            Start Date and Time
                            <span className="text-danger"> *</span>
                          </Label>
                          <LabelText
                            htmlFor={`grants[${keyIndex}].startDateTime`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              (touched?.grants &&
                                touched?.grants?.[keyIndex] &&
                                !values?.grants?.[keyIndex]?.startDateTime &&
                                !disableValidityInGrantOne[keyIndex]) ||
                              false
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.grants?.[keyIndex]?.startDateTime &&
                              errors?.grants?.[keyIndex]?.startDateTime
                                ? errors?.grants?.[keyIndex]?.startDateTime
                                : "Select Start Date and Time"
                            }
                          />
                          <CommonDateTimePicker
                            name={`grants[${keyIndex}].startDateTime`}
                            placeholder={" "}
                            className={`form-control ${
                              isSubscribed
                                ? "label-disable-color-edit-offer"
                                : ""
                            } ${
                              touched?.grants?.[keyIndex] &&
                              !values?.grants?.[keyIndex]?.startDateTime &&
                              !disableValidityInGrantOne[keyIndex]
                                ? "error-input"
                                : ""
                            }`}
                            style={{
                              height: "38px",
                              fontSize: "0.875rem",
                              borderRadius: "0.5rem",
                            }}
                            type="datetime-local"
                            disabled={isSubscribed}
                            minDate={moment()}
                            handleChange={(newValue) => {
                              setFieldValue(
                                `grants[${keyIndex}].startDateTime`,
                                newValue
                              );
                            }}
                            value={values.grants?.[keyIndex].startDateTime}
                          />
                        </Col>
                      )}
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label for={`grants[${keyIndex}].validityEndsOn`}>
                          Validity Ends<span className="text-danger"> *</span>
                        </Label>
                        <LabelText
                          htmlFor={`grants[${keyIndex}].validityEndsOn`}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            (touched?.grants &&
                              touched?.grants?.[keyIndex] &&
                              !values?.grants?.[keyIndex]?.validityEndsOn &&
                              !disableValidityInGrantOne[keyIndex]) ||
                            false
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          } `}
                          displayText={
                            touched?.grants?.[keyIndex]?.validityEndsOn &&
                            errors?.grants?.[keyIndex]?.validityEndsOn
                              ? errors?.grants?.[keyIndex]?.validityEndsOn
                              : "Select Validity Ends"
                          }
                        />
                        <SelectField
                          isLoading={loading}
                          className={
                            (touched.grants &&
                              touched.grants?.[keyIndex] &&
                              !values.grants?.[keyIndex].validityEndsOn &&
                              !disableValidityInGrantOne[keyIndex]) ||
                            false
                              ? "error-input"
                              : ""
                          }
                          name={`grants[${keyIndex}].validityEndsOn`}
                          placeholder={" "}
                          isDisabled={
                            (isEdit && isSubscribed) ||
                            (disableValidityInGrantOne[keyIndex] && isCreate)
                          }
                          value={values.grants?.[keyIndex].validityEndsOn}
                          handleChange={(value) => {
                            setFieldValue(
                              `grants[${keyIndex}].validityEndsOn`,
                              value
                            );
                          }}
                          isRVStyle={true}
                          options={
                            values.grants?.[keyIndex]?.validityStartsOn
                              ?.label === "Specific Time"
                              ? GrantsValidityEnd?.filter(
                                  (_, idx) => idx !== 0 && idx !== 2
                                )
                              : GrantsValidityEnd
                          }
                        />
                      </Col>
                      {values.grants?.[keyIndex]?.validityEndsOn?.label ===
                        "Specific Time" && (
                        <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                          <Label>
                            End Date and Time
                            <span className="text-danger"> *</span>
                          </Label>
                          <LabelText
                            htmlFor={`grants[${keyIndex}].endDateTime`}
                            classLabelName={`d-block ms-0 rv-sub-label ${
                              (touched?.grants &&
                                touched?.grants?.[keyIndex] &&
                                !values?.grants?.[keyIndex]?.endDateTime &&
                                !disableValidityInGrantOne[keyIndex]) ||
                              false
                                ? "rv-label-danger"
                                : "rv-label-muted"
                            } `}
                            displayText={
                              touched?.grants?.[keyIndex]?.endDateTime &&
                              errors?.grants?.[keyIndex]?.endDateTime
                                ? errors?.grants?.[keyIndex]?.endDateTime
                                : "Select End Date and Time"
                            }
                          />
                          <CommonDateTimePicker
                            name={`grants[${keyIndex}].endDateTime`}
                            placeholder={" "}
                            className={`form-control ${
                              isSubscribed
                                ? "label-disable-color-edit-offer"
                                : ""
                            } ${
                              touched?.grants?.[keyIndex] &&
                              !values?.grants?.[keyIndex]?.endDateTime &&
                              !disableValidityInGrantOne[keyIndex]
                                ? "error-input"
                                : ""
                            }`}
                            type="datetime-local"
                            style={{
                              height: "38px",
                              fontSize: "0.875rem",
                              borderRadius: "0.5rem",
                            }}
                            disabled={isSubscribed}
                            minDateTime={values.grants?.[keyIndex].endDateTime}
                            handleChange={(newValue) => {
                              setFieldValue(
                                `grants[${keyIndex}].endDateTime`,
                                newValue
                              );
                            }}
                            value={values.grants?.[keyIndex].endDateTime}
                          />
                        </Col>
                      )}
                      {values.grants?.[keyIndex]?.validityEndsOn?.label ===
                        "Relative" && (
                        <Col md={12} lg={8} xxl={6} className="mb-3">
                          <Row>
                            <Col xxl={6} md={6} lg={6}>
                              <Label>Time Period</Label>
                              <LabelText
                                htmlFor={`grants[${keyIndex}].grantValidityEndsOnTimeperiod`}
                                classLabelName={`d-block ms-0 rv-sub-label ${
                                  (touched?.grants &&
                                    touched?.grants?.[keyIndex] &&
                                    errors?.grants?.[keyIndex]
                                      ?.grantValidityEndsOnTimeperiod &&
                                    !disableValidityInGrantOne[keyIndex]) ||
                                  false
                                    ? "rv-label-danger"
                                    : "rv-label-muted"
                                } `}
                                displayText={
                                  touched?.grants?.[keyIndex]
                                    ?.grantValidityEndsOnTimeperiod &&
                                  errors?.grants?.[keyIndex]
                                    ?.grantValidityEndsOnTimeperiod
                                    ? errors?.grants?.[keyIndex]
                                        ?.grantValidityEndsOnTimeperiod
                                    : "Enter Time Period"
                                }
                              />
                              <InputField
                                name={`grants[${keyIndex}].grantValidityEndsOnTimeperiod`}
                                disabled={isSubscribed}
                                type={"number"}
                                className={`form-control ${
                                  isSubscribed
                                    ? "label-disable-color-edit-offer"
                                    : ""
                                }`}
                                id={"grantValidityEndsOnTimeperiod"}
                                handleChange={handleChange}
                                value={
                                  values?.grants?.[keyIndex]
                                    ?.grantValidityEndsOnTimeperiod
                                }
                              />
                            </Col>
                            <Col
                              xxl={6}
                              md={6}
                              lg={6}
                              data-testid="select-component"
                              style={{ marginTop: "55px" }}
                              className="mb-3"
                            >
                              <SelectField
                                name={`grants[${keyIndex}].grantValidityEndsOn`}
                                placeholder={" "}
                                isDisabled={isSubscribed}
                                value={
                                  values.grants?.[keyIndex]
                                    .grantValidityEndsOn || ""
                                }
                                handleChange={(val) => {
                                  values.grants[keyIndex].grantValidityEndsOn =
                                    val;
                                  setFieldValue(
                                    `grants[${keyIndex}].grantValidityEndsOn`,
                                    val
                                  );
                                }}
                                options={TimePeriodGrantOptions}
                                isRVStyle={true}
                              />
                            </Col>
                          </Row>
                        </Col>
                      )}
                      <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                        <Label>Override</Label>
                        <LabelText
                          htmlFor={`grants[${keyIndex}].override`}
                          classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
                          displayText={"Enable / Disable Override"}
                        />
                        <FormGroup
                          switch
                          className="d-flex align-items-start switch-state"
                        >
                          <div className="me-2">
                            <Input
                              name={`grants[${keyIndex}].override`}
                              type="switch"
                              className="rv-form-switch-input"
                              disabled={isEdit}
                              checked={values?.grants?.[keyIndex]?.override}
                              onChange={() =>
                                handleGrantsOverrideState(
                                  keyIndex,
                                  values,
                                  setFieldValue
                                )
                              }
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                );
              })
            )}
          </div>
        );
      }}
    </FieldArray>
  );
}
